var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpace = function SvgSpace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9.288 8.534 1.342-.67a.52.52 0 0 0 .233-.234l.671-1.342a.52.52 0 0 1 .931 0l.672 1.342c.05.101.132.183.233.233l1.342.671a.52.52 0 0 1 0 .932l-1.342.67a.52.52 0 0 0-.233.234l-.671 1.342a.52.52 0 0 1-.931 0l-.672-1.342a.52.52 0 0 0-.233-.233l-1.342-.671a.52.52 0 0 1 0-.932Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M5.18 18.25a9.225 9.225 0 0 1 6.82-3c2.7 0 5.128 1.156 6.82 3m-13.64 0a9.225 9.225 0 0 0 6.82 3c2.7 0 5.128-1.156 6.82-3m-13.64 0a9.25 9.25 0 1 1 13.638 0"
  })));
};
export default SvgSpace;